import { plaintextValidator } from '../fields';

const config = { mandatory: true };

export default {
  apiToken: plaintextValidator(config),
  tenantId: plaintextValidator(config)
};
